import React from "react";
import { Link } from "react-router-dom";
import SensorIcon from "components/gateways/SensorIcon";

export type SensorNameRenderer = (row: any) => React.ReactNode;

/** Optional: when provided, Link uses this URL so "open in new tab" works. */
export type GetRowTo = (row: any, tabKey: string) => string;

export const createSensorNameRenderer = (
    tabKey: string,
    handleRowClick: (row: any, tabKey: string) => void,
    getRowTo?: GetRowTo
): SensorNameRenderer => {
    return (row: any) => {
        const to = getRowTo?.(row, tabKey) ?? "#";
        return (
            <Link
                to={to}
                onClick={to === "#" ? (e) => {
                    e.preventDefault();
                    handleRowClick(row, tabKey);
                } : undefined}
            >
                <span>
                    <SensorIcon
                        sensorType={row.type ?? row.sensor_type ?? "Generic Analog Input"}
                        style={{ marginRight: 15 }}
                    />
                    <span>{row.sensor_name ?? row.name}</span>
                </span>
            </Link>
        );
    };
};

